<template src="./NotLoggedIn.html"> </template>
<script>
export default {
    name: 'SocialNotLoggedIn',
}
</script>


<style lang="scss" src="./NotLoggedIn.scss"></style>